import {DomainObject} from 'shared/store';
import {observable, action} from 'mobx';
import {Employee} from 'main/stores/employees';
import ExpensePolicyApprover from './ExpensePolicyApprover';
import _ from 'lodash';

class ExpensePolicy extends DomainObject {
  @observable id;
  @observable name;
  @observable employees;
  @observable approvers = [];

  @action merge(other) {
    super.merge(other, {
      employees: [Employee],
      approvers: [ExpensePolicyApprover]
    });
  }

  @action addApprover(approver) {
    this.approvers.push(approver);
  }

  @action removeApprover(approver) {
    this.approvers = _.reject(this.approvers, {value: approver.value});
  }

  @action setEmployees(employees) {
    this.employees.replace(employees);
  }
}

export default ExpensePolicy;
